import { SCHEMA_VERSION } from "./config.js";
import { flattenBrandJson } from "./shape.js";
// The contract's versioning policy: an added optional field never bumps
// `schemaVersion`; a rename or a change of meaning bumps it and ships its
// migration here, so every reader accepts every version up to its own; an
// unknown version is refused by validation. Version 1 is the first shipped.
export const SUPPORTED_SCHEMA_VERSIONS = [SCHEMA_VERSION];
/** The boundary every reader goes through, and where a future migration runs. */
export function migrateBrandConfig(input) {
    return flattenBrandJson(input);
}
